import { Box } from '@mui/material';
import { styled } from '@mui/system';

import { keyframes } from '@emotion/react';

import styles from './DotsLoader.module.scss';

const { bgColor } = styles;
const bounce = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
`;

const Dot = styled(Box)(() => ({
	width: 5,
	height: 5,
	backgroundColor: bgColor,
	borderRadius: '50%',
	display: 'inline-block',
	margin: '0 5px',
	animation: `${bounce} 0.6s infinite alternate`,
}));

const DotsContainer = styled(Box)({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
});

const DotsLoader = () => (
	<DotsContainer>
		<Dot style={{ animationDelay: '0s' }} />
		<Dot style={{ animationDelay: '0.2s' }} />
		<Dot style={{ animationDelay: '0.4s' }} />
	</DotsContainer>
);

export default DotsLoader;
